import React from 'react';
import PropTypes from 'prop-types';

const ThankYouBox = props => (
  <section className="site-width thank-you-box">
    <h3>
      {`${props.translations['thank-you']} ${
        props.translations['comments-added']
      }`}
    </h3>
    <button
      id="thank-you-button"
      style={{ backgroundColor: props.color }}
      onClick={() => props.allDoneClick(true)}
    >
      {props.translations['thanks-done']}
    </button>
  </section>
);

ThankYouBox.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  allDoneClick: PropTypes.func.isRequired,
};

export default ThankYouBox;
